export const APPOINTMENT_REQUEST_SENT = "Pending Approval";
export const APPOINTMENT_PENDING_FOR_APPROVAL = "Pending Approval";
export const APPOINTMENT_APPROVED = "Approved";
export const APPOINTMENT_RESCHEDULED = "Rescheduled";
export const RESCHEDULED_APPOINTMENT_APPROVED = "Rescheduled Approved";
export const APPOINTMENT_COMPLETED = "Completed";
export const REJECTED_BY_DOCTOR = "Rejected by Doctor";
export const REJECTED_BY_PATIENT = "Rejected by Patient";
export const REJECTED_BY_ADMIN = "Rejected by Admin";
export const REJECTED_BY_SYSTEM = "Rejected by System";
